import React from "react";

/**
 * Single source of truth for the agent flight step 2-col shell:
 * `fw-main-split` = primary (panel) + optional summary rail, matching FlightWizard.css
 * (incl. `fw-root[data-fw-step="flightDetails"]` breakpoints and mobile order).
 *
 * @param {object} props
 * @param {React.ReactNode} props.primaryPanel - Content inside `fw-panel` (e.g. step body)
 * @param {React.ReactNode} [props.primaryAfter] - e.g. navigation + dev tools (sibling of panel, inside primary column)
 * @param {React.ReactNode} [props.summary] - עמודת sidebar: `FlightBookingSidebar`, `FlightSummaryRail`, או null (שלב תוצאות)
 * @param {string} [props.panelKey] - key on the panel (step switches)
 * @param {string} [props.className] - extra class on the split (e.g. `fw-main-split--no-sidebar` handled by no summary, but allow override)
 * @param {boolean} [props.equalHeightCards] - stretch sidebar + panel to one height; nav sits below the cards
 */
export default function FlightDetailsSplitLayout({
  primaryPanel,
  primaryAfter = null,
  summary = null,
  panelKey = undefined,
  className = "",
  equalHeightCards = false,
}) {
  const stretchCards = Boolean(equalHeightCards && summary);
  const splitClass = [
    "fw-main-split",
    !summary ? "fw-main-split--no-sidebar" : "fw-main-split--with-summary",
    stretchCards ? "fw-main-split--equal-cards" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const primaryCol = (
    <div className="fw-main-split__primary">
      <div key={panelKey} className="fw-panel fw-panel--enter">
        {primaryPanel}
      </div>
      {stretchCards ? null : primaryAfter}
    </div>
  );

  return (
    <div className={splitClass}>
      {stretchCards ? (
        <div className="fw-main-split__cards">
          {primaryCol}
          {summary}
        </div>
      ) : (
        <>
          {primaryCol}
          {summary}
        </>
      )}
      {stretchCards ? primaryAfter : null}
    </div>
  );
}
